// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.4142 1H3V23H21V6.58579L15.4142 1ZM14.5 7.5V3L19 7.5H14.5ZM13.3623 10.5902L15.5001 13.0979V14.5047H8.50005V12.5047H12.3662L11.8403 11.8877L13.3623 10.5902ZM8.5 15.4953H15.4964V17.4953H11.6338L12.1598 18.1123L10.6377 19.4097L8.5 16.9021V15.4953Z"}}]};

const FileTransmitFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-transmit-filled',
    ref,
    icon: element,
  },
));

FileTransmitFilledIcon.displayName = 'FileTransmitFilledIcon';

export default FileTransmitFilledIcon;
